import { useContext } from "react";

import { FlagContext } from "@/context/Flag";

import { Flag } from "@/external/flags";

export function useFlag(key: string): Flag | undefined {
    return useContext(FlagContext).get(key);
}
